import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/ics_o_commodity.svg'
import _imports_1 from '@/app/ui/assets/svg/ics_f_announce_green.svg'
import _imports_2 from '@/app/ui/assets/svg/reload-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-6537658e")

_pushScopeId("data-v-6537658e")
const _hoisted_1 = { class: "border border-gray-lp-100 bg-white rounded-xl shadow-lg p-3 w-full" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-4.5 max-w-none",
  alt: "commodity-icon"
}, null, -1)
const _hoisted_4 = { class: "text-14px font-semibold pl-2" }
const _hoisted_5 = { class: "flex bg-green-lp-500 rounded-lg text-green-lp-200 px-2 text-12px items-center ml-2" }
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-5 h-5 max-w-none",
  alt: "announce-fill"
}, null, -1)
const _hoisted_7 = { class: "pl-2" }
const _hoisted_8 = {
  tabIndex: "-1",
  class: "font-semibold underline cursor-pointer pl-1",
  href: "https://lionparcel.com/sk",
  target: "_blank"
}
const _hoisted_9 = { class: "w-full flex flex-row justify-between items-center" }
const _hoisted_10 = { class: "flex flex-row ml-1 items-center" }
const _hoisted_11 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_12 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_13 = { class: "flex flex-row ml-1 items-center" }
const _hoisted_14 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_15 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_16 = {
  key: 0,
  class: "grid grid-cols-3 gap-2 mt-2"
}
const _hoisted_17 = {
  key: 1,
  class: "flex justify-between items-center pt-2"
}
const _hoisted_18 = { class: "text-12px" }
const _hoisted_19 = { class: "text-10px text-gray-lp-800" }
const _hoisted_20 = /*#__PURE__*/_createVNode("img", {
  src: _imports_2,
  class: "w-4 h-4 mr-1 max-w-none",
  alt: "reload-icon"
}, null, -1)
const _hoisted_21 = { class: "text-10px text-red-lp-100" }
const _hoisted_22 = {
  key: 2,
  class: "grid grid-cols-3 gap-2 mt-2 recommendation-container"
}
const _hoisted_23 = { class: "flex justify-between items-center w-full" }
const _hoisted_24 = { class: "text-12px overflow-ellipsis whitespace-nowrap overflow-hidden" }
const _hoisted_25 = { class: "flex flex-row ml-1 items-center" }
const _hoisted_26 = {
  key: 0,
  class: "bg-yellow-lp-200 rounded text-center text-yellow-lp-100 font-medium text-xs px-1"
}
const _hoisted_27 = {
  key: 1,
  class: "ml-1 bg-red-lp-600 rounded text-center text-red-lp-1600 font-medium text-xs px-1"
}
const _hoisted_28 = { class: "w-full flex flex-col text-12px" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!
  const _component_CommodityModalAll = _resolveComponent("CommodityModalAll")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("bookingV3.commodity")), 1),
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("bookingV3.commodityNote")), 1),
          _createVNode("a", _hoisted_8, _toDisplayString(_ctx.$t("bookingV3.commodityTnC")), 1)
        ])
      ]),
      _createVNode(_component_SelectSearch, {
        id: `select_search_komoditas_${_ctx.id}`,
        class: "mt-1.5",
        options: _ctx.commodities,
        isLoading: _ctx.isLoadingCommodity,
        onFilter: _ctx.fetchCommodityList,
        keyName: "name",
        keyValue: "code",
        placeholder: _ctx.$t('bookingV3.commodityPlaceholder'),
        modelValue: _ctx.modelValue.commodity,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.commodity = $event)),
        isShowErrorMessage: true,
        isShowErrorIndicator: _ctx.errorIndicator,
        errorCaption: _ctx.errorMessage,
        onChange: _ctx.changeCommodities,
        onFocus: _ctx.onFocusCommodityList,
        maxHeight: "270px",
        useInfiniteScroll: "",
        onScrolled: _ctx.fetchCommodityListInfiniteScroll,
        idInput: "commodity-booking",
        autoUpDown: "",
        isSearchIcon: "",
        isViewAll: "",
        onClickViewAll: _cache[2] || (_cache[2] = ($event: any) => (_ctx.disabled ? {} : _ctx.clickViewAll())),
        isDisabled: _ctx.disabled,
        disabledBackground: _ctx.disabled,
        isFirstLanding: true,
        errorMessage: _ctx.$t('bookingV3.commodityNotFound')
      }, {
        "custom-option": _withId(({ item }) => [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", null, _toDisplayString(item.name), 1),
            _createVNode("div", _hoisted_10, [
              (item.isQuarantine)
                ? (_openBlock(), _createBlock("span", _hoisted_11, " K "))
                : _createCommentVNode("", true),
              (item.isDangerousGoods)
                ? (_openBlock(), _createBlock("span", _hoisted_12, " DG "))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        "selected-info": _withId(({ selected }) => [
          _createVNode("div", _hoisted_13, [
            (selected && selected.isQuarantine)
              ? (_openBlock(), _createBlock("span", _hoisted_14, " K "))
              : _createCommentVNode("", true),
            (selected && selected.isDangerousGoods)
              ? (_openBlock(), _createBlock("span", _hoisted_15, " DG "))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["id", "options", "isLoading", "onFilter", "placeholder", "modelValue", "isShowErrorIndicator", "errorCaption", "onChange", "onFocus", "onScrolled", "isDisabled", "disabledBackground", "errorMessage"]),
      (_ctx.isLoadingCommodity)
        ? (_openBlock(), _createBlock("div", _hoisted_16, [
            _createVNode("div", null, [
              _createVNode(_component_Skeleton, {
                width: "100%",
                height: "1.5rem"
              })
            ]),
            _createVNode("div", null, [
              _createVNode(_component_Skeleton, {
                width: "100%",
                height: "1.5rem"
              })
            ]),
            _createVNode("div", null, [
              _createVNode(_component_Skeleton, {
                width: "100%",
                height: "1.5rem"
              })
            ])
          ]))
        : (!_ctx.isLoadingCommodity && _ctx.isErrorCommodity)
          ? (_openBlock(), _createBlock("div", _hoisted_17, [
              _createVNode("div", null, [
                _createVNode("div", _hoisted_18, _toDisplayString(_ctx.$t("bookingV3.commodityRecommendationErrorTitle")), 1),
                _createVNode("div", _hoisted_19, _toDisplayString(_ctx.$t("bookingV3.commodityRecommendationErrorMessage")), 1)
              ]),
              _createVNode("div", {
                class: "flex flex-row cursor-pointer",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.getCommodityRecommendedList && _ctx.getCommodityRecommendedList(...args)))
              }, [
                _hoisted_20,
                _createVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("bookingV3.commodityRecommendationErrorButton")), 1)
              ])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_22, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dataRecommendedCommodities, (recommend) => {
                return (_openBlock(), _createBlock("div", {
                  key: recommend.commodity_id
                }, [
                  _createVNode("label", {
                    class: [
            `border rounded-lg px-2 py-1 flex justify-between cursor-pointer ${
              _ctx.isSelectedRecommendation(recommend.commodity_code)
                ? 'border-red-lp-100 bg-pink-lp-200 text-red-lp-1600'
                : 'border-gray-lp-400 hover:bg-gray-lp-1800 hover:text-gray-lp-300'
            } ${_ctx.disabled ? 'cursor-not-allowed opacity-50' : ''}`
          , "relative block overflow-hidden"],
                    onMouseenter: ($event: any) => (_ctx.toggleTooltip($event, recommend.commodity_code)),
                    onMouseleave: ($event: any) => (_ctx.toggleTooltip($event, recommend.commodity_code))
                  }, [
                    _createVNode("input", {
                      type: "radio",
                      name: `commodity-recommendation-${_ctx.id}`,
                      value: recommend.commodity_code,
                      checked: _ctx.isSelectedRecommendation(recommend.commodity_code),
                      id: `commodity-${recommend.commodity_code}-${_ctx.id}`,
                      onChange: () => _ctx.disabled ? {} : _ctx.onChoose(recommend),
                      class: "z-10 absolute opacity-0",
                      disabled: _ctx.disabled
                    }, null, 40, ["name", "value", "checked", "id", "onChange", "disabled"]),
                    _createVNode("div", _hoisted_23, [
                      _createVNode("div", _hoisted_24, _toDisplayString(_ctx.ellipsisText(
                  _ctx.accountIsNonForeign
                    ? recommend.commodity_name
                    : recommend.commodity_name_en,
                  16
                )), 1),
                      _createVNode("div", _hoisted_25, [
                        (recommend.isQuarantine)
                          ? (_openBlock(), _createBlock("span", _hoisted_26, " K "))
                          : _createCommentVNode("", true),
                        (recommend.isDangerousGoods)
                          ? (_openBlock(), _createBlock("span", _hoisted_27, " DG "))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ], 42, ["onMouseenter", "onMouseleave"]),
                  _createVNode(_component_OverlayPanel, {
                    ref: recommend.commodity_code,
                    appendTo: "body",
                    style: [{"width":"190px","font-weight":"400"}, {
            backgroundColor: '#ffffff',
            color: '#4D4D4D'
          }]
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_28, [
                        _createVNode("div", null, _toDisplayString(_ctx.accountIsNonForeign
                  ? recommend.commodity_name
                  : recommend.commodity_name_en), 1)
                      ])
                    ]),
                    _: 2
                  }, 1536)
                ]))
              }), 128))
            ]))
    ]),
    (_ctx.isModalViewAll)
      ? (_openBlock(), _createBlock(_component_CommodityModalAll, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isModalViewAll = $event)),
          modelValue: _ctx.modelValue.commodity,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.commodity = $event)),
          clientCountry: _ctx.modelValue.clientName.clientCountry,
          onChange: _ctx.onChoose
        }, null, 8, ["modelValue", "clientCountry", "onChange"]))
      : _createCommentVNode("", true)
  ], 64))
})